<template>
	<tr
		:class="{ 'table-secondary text-muted': voce.FLG_DA_CALCOLARE == 0, 'table-danger text-muted': voce.FLG_ELIMINATO == 1 }"
	>
		<!-- Colonna # (ordine) -->
		<td v-if="!$root.isMobile" class="table-head-sm text-center voce-cell voce-cell-index" data-width="3%;">
			<i v-if="dragEnabled" class="ph-dots-six-vertical drag-handle-voce cursor-move" :title="$root.translate('dizionario.attivita.TRASCINA_SPOSTA_VOCE')" @click.stop></i>
			<small v-else>{{ voce.ORDINE }}</small>
		</td>

		<!-- ===== DESKTOP: colonne classiche ===== -->
		<template v-if="!$root.isMobile">
			<!-- GRUPPO VENDITA -->
			<td class="table-head-sm voce-cell voce-cell-vendita" style="word-wrap: break-word; white-space: normal; border-left: 1px solid #e8e8e8; border-right: 1px solid #e8e8e8;">
				<div :style="{ marginLeft: '8px' }">
					<i
						class="ph-file-text me-1"
						:class="isTitleTruncated ? 'text-warning' : 'text-muted'"
						:style="{ cursor: isTitleTruncated ? 'pointer' : 'default' }"
						@click.stop="isTitleTruncated && (titleExpanded = !titleExpanded)"
					></i>{{ titleExpanded ? voce.TITOLO_VOCE : filters.accorciaTesto(voce.TITOLO_VOCE, 100) }}
					<span v-if="voce.FLG_DA_CALCOLARE == 0" class="badge bg-secondary ms-1" style="font-size:0.6rem;"><Translate :path="'dizionario.attivita.ESCLUSA'"></Translate></span>
				</div>
			</td>
			<td class="table-head-sm text-end voce-cell voce-cell-vendita" style="border-left: 1px solid #e8e8e8; border-right: 1px solid #e8e8e8;" data-width="6%;">
				{{ parseFloat(voce.QUANTITY_PRICE) }}
			</td>
			<td class="table-head-sm text-end voce-cell voce-cell-vendita" style="border-left: 1px solid #e8e8e8; border-right: 1px solid #e8e8e8;" data-width="6%;">
				{{ parseFloat(voce.DAYS_PRICE) }}
			</td>
			<td class="table-head-sm text-end voce-cell voce-cell-vendita" style="border-left: 1px solid #e8e8e8; border-right: 1px solid #e8e8e8;" data-width="9%;">
				<template v-if="voce.FLG_OMAGGIO_UNIT_PRICE == 1">
					<span class="badge bg-primary bg-opacity-20 text-primary" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
				</template>
				<template v-else>
					<span class="text-muted" style="font-size:0.75rem;">&euro; {{ voce.UNIT_PRICE }}</span>
				</template>
			</td>
			<td class="table-head-sm text-end voce-cell voce-cell-vendita" style="border-left: 1px solid #e8e8e8; border-right: 20px solid white !important;" data-width="9%;">
				<template v-if="voce.FLG_OMAGGIO_TOTAL_PRICE == 1">
					<span class="badge bg-primary bg-opacity-20 text-primary" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
				</template>
				<template v-else>
					<span class="text-primary fs-sm fw-semibold">&euro; {{ voce.TOTAL_PRICE }}</span>
					<span v-if="ivaCode"
						class="badge bg-secondary ms-1"
						style="font-size:0.65rem;"
						:title="ivaCode.DESCRIZIONE">
						{{ ivaCode.CUSTOM_1 }}
					</span>
					<span v-if="voce.FEE > 0"
						class="badge bg-info bg-opacity-20 text-info ms-1"
						style="font-size:0.65rem;"
						:title="'Fee: ' + voce.FEE + '%'">
						fee {{ voce.FEE }}%
					</span>
				</template>
			</td>

			<!-- GRUPPO ACQUISTO -->
			<td class="table-head-sm text-end voce-cell voce-cell-acquisto" style="border-left: 20px solid white !important; border-right: 1px solid #FFD648;" data-width="7%;">
				<template v-if="voce.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1">
					<span class="badge bg-danger bg-opacity-20 text-danger" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
				</template>
				<template v-else>
					<span class="text-muted" style="font-size:0.75rem;">&euro; {{ voce.UNIT_COST_ESPOSTO }}</span>
				</template>
			</td>
			<td class="table-head-sm text-end voce-cell voce-cell-acquisto" style="border-left: 1px solid #FFD648; border-right: 1px solid #FFD648;" data-width="7%;">
				<template v-if="voce.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1">
					<span class="badge bg-danger bg-opacity-20 text-danger" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
				</template>
				<template v-else>
					<span class="text-danger fs-sm fw-semibold">&euro; {{ voce.TOTAL_COST_ESPOSTO }}</span>
					<span v-if="ivaCodiceAcquisto"
						class="badge bg-secondary ms-1"
						style="font-size:0.65rem;"
						:title="ivaCodiceAcquisto.DESCRIZIONE">
						{{ ivaCodiceAcquisto.CUSTOM_1 }}
					</span>
				</template>
			</td>
			<td class="table-head-sm text-end voce-cell voce-cell-acquisto" style="border-left: 1px solid #FFD648; border-right: 1px solid #FFD648;" data-width="7%;">
				<template v-if="voce.FLG_OMAGGIO_TOTAL_COST_PRIVATO == 1">
					<span class="badge bg-warning bg-opacity-20 text-warning" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
				</template>
				<template v-else>
					<span class="text-warning fs-sm fw-semibold">&euro; {{ voce.TOTAL_COST_PRIVATO }}</span>
					<span v-if="ivaCodiceCommissioni"
						class="badge bg-secondary ms-1"
						style="font-size:0.65rem;"
						:title="ivaCodiceCommissioni.DESCRIZIONE">
						{{ ivaCodiceCommissioni.CUSTOM_1 }}
					</span>
				</template>
			</td>
			<td class="table-head-sm text-end voce-cell voce-cell-fornitore" style="border-left: 1px solid #FFD648; border-right: 1px solid #FFD648;" data-width="15%;">
				<span v-if="voce.FORNITORE" class="text-muted" style="font-size:0.75rem;">{{ filters.accorciaTesto(voce.FORNITORE, 50) }}</span>
				<span v-else class="text-muted fst-italic" style="font-size:0.7rem;">-</span>
			</td>

			<!-- Colonna Azioni -->
			<td v-if="!readOnly" class="td-class text-center voce-cell voce-cell-actions actions-cell" data-width="9%;">
				<div class="d-flex align-items-center justify-content-center">
					<div v-if="!dragEnabled" class="dropdown" ref="dropdownEl">
						<a
							href="#"
							class="text-body p-0 ms-1"
							@click.prevent="toggleDropdown"
							:aria-expanded="dropdownOpen"
							:title="$root.translate('dizionario.base.AZIONI')"
							ref="dropdownToggle"
						>
							<i class="ph-list"></i>
						</a>

						<!-- Teleport il menu dropdown fuori dalla gerarchia ricorsiva -->
						<Teleport to="body">
							<div
								v-if="dropdownOpen"
								class="dropdown-menu dropdown-menu-end show"
								:style="dropdownStyle"
								@click="handleMenuClick"
							>
								<a href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni-voce', { azione: 'modifica', voce, attivita }); closeDropdown()">
									<i class="far fa-edit fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_MODIFICA'"></Translate>
								</a>
								<a href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni-voce', { azione: 'aggiungi-preferito', voce, attivita }); closeDropdown()">
									<i class="far fa-star fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.attivita.AGGIUNGI_PREFERITI'"></Translate>
								</a>
								<a href="#" class="dropdown-item" v-if="$root.isGod" @click.prevent="toggleFlgAttivoVoce(voce.FLG_ATTIVO_VOCE == 1 ? 0 : 1); closeDropdown()">
									<i :class="voce.FLG_ATTIVO_VOCE == 1 ? 'far fa-times-circle' : 'far fa-check-circle'" class="fa-fw me-2"></i><span class="text-muted me-1">|</span>{{ $root.translate(voce.FLG_ATTIVO_VOCE == 1 ? 'dizionario.base.BTN_DISATTIVA' : 'dizionario.base.BTN_ATTIVA') }}
								</a>
								<div class="dropdown-divider" v-if="$root.isGod"></div>
								<a href="#" class="dropdown-item text-danger" v-if="voce.FLG_ELIMINATO != 1" @click.prevent="$emit('apri-azioni-voce', { azione: 'elimina', voce, attivita }); closeDropdown()">
									<i class="far fa-trash-alt fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_ELIMINA'"></Translate>
								</a>
								<a href="#" class="dropdown-item text-danger" v-if="$root.isGod && voce.FLG_ELIMINATO == 1" @click.prevent="$emit('apri-azioni-voce', { azione: 'elimina-definitivamente', voce, attivita }); closeDropdown()">
									<i class="far fa-trash fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_ELIMINA_DEF'"></Translate>
								</a>
								<a href="#" class="dropdown-item text-success" v-if="$root.isGod && voce.FLG_ELIMINATO == 1" @click.prevent="$emit('apri-azioni-voce', { azione: 'ripristina', voce, attivita }); closeDropdown()">
									<i class="far fa-redo fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_RIPRISTINA'"></Translate>
								</a>
							</div>
						</Teleport>
					</div>
				</div>
			</td>
			<td v-else class="voce-cell voce-cell-actions" data-width="9%;"></td>
		</template>

		<!-- ===== MOBILE: card compatta con dettagli espandibili ===== -->
		<template v-else>
			<td colspan="11" class="p-0 voce-mobile-cell">
				<div class="voce-mobile-row" @click="mobileDetailExpanded = !mobileDetailExpanded">
					<div class="d-flex align-items-center p-2" :class="{ 'flex-wrap': titleExpanded && isTitleTruncated }">
						<div class="d-flex align-items-center" :class="(titleExpanded && isTitleTruncated) ? 'w-100' : 'flex-grow-1 min-w-0'">
							<i
								class="ph-file-text me-1 flex-shrink-0"
								:class="isTitleTruncated ? 'text-warning' : 'text-muted'"
								:style="{ cursor: isTitleTruncated ? 'pointer' : 'default' }"
								@click.stop="isTitleTruncated && (titleExpanded = !titleExpanded)"
							></i>
							<span :class="(titleExpanded && isTitleTruncated) ? '' : 'text-truncate'">{{ (titleExpanded && isTitleTruncated) ? voce.TITOLO_VOCE : filters.accorciaTesto(voce.TITOLO_VOCE, 60) }}</span>
							<span v-if="voce.FLG_DA_CALCOLARE == 0" class="badge bg-secondary ms-1 flex-shrink-0" style="font-size:0.6rem;"><Translate :path="'dizionario.attivita.ESCLUSA'"></Translate></span>
						</div>
						<div v-if="titleExpanded && isTitleTruncated" class="d-flex align-items-center justify-content-between w-100 mt-1">
							<div class="d-flex align-items-center">
								<span class="badge bg-primary bg-opacity-20 text-primary me-1" style="font-size:0.7rem;">&euro; {{ voce.TOTAL_PRICE }}</span>
								<span class="badge bg-danger bg-opacity-20 text-danger" style="font-size:0.7rem;">&euro; {{ voce.TOTAL_COST_ESPOSTO }}</span>
							</div>
							<div class="d-flex align-items-center">
								<i v-if="dragEnabled" class="ph-dots-six-vertical drag-handle-voce cursor-move ms-2" :title="$root.translate('dizionario.attivita.TRASCINA_SPOSTA_VOCE')" @click.stop></i>
								<div v-if="!readOnly && !dragEnabled" class="dropdown ms-2" ref="dropdownEl" @click.stop>
									<a
										href="#"
										class="text-body p-0"
										@click.prevent="toggleDropdown"
										:aria-expanded="dropdownOpen"
										:title="$root.translate('dizionario.base.AZIONI')"
										ref="dropdownToggle"
									>
										<i class="ph-list"></i>
									</a>

									<Teleport to="body">
										<div
											v-if="dropdownOpen"
											class="dropdown-menu dropdown-menu-end show"
											:style="dropdownStyle"
											@click="handleMenuClick"
										>
											<a href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni-voce', { azione: 'modifica', voce, attivita }); closeDropdown()">
												<i class="far fa-edit fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_MODIFICA'"></Translate>
											</a>
											<a href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni-voce', { azione: 'aggiungi-preferito', voce, attivita }); closeDropdown()">
												<i class="far fa-star fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.attivita.AGGIUNGI_PREFERITI'"></Translate>
											</a>
											<a href="#" class="dropdown-item" v-if="$root.isGod" @click.prevent="toggleFlgAttivoVoce(voce.FLG_ATTIVO_VOCE == 1 ? 0 : 1); closeDropdown()">
												<i :class="voce.FLG_ATTIVO_VOCE == 1 ? 'far fa-times-circle' : 'far fa-check-circle'" class="fa-fw me-2"></i><span class="text-muted me-1">|</span>{{ $root.translate(voce.FLG_ATTIVO_VOCE == 1 ? 'dizionario.base.BTN_DISATTIVA' : 'dizionario.base.BTN_ATTIVA') }}
											</a>
											<div class="dropdown-divider" v-if="$root.isGod"></div>
											<a href="#" class="dropdown-item text-danger" v-if="voce.FLG_ELIMINATO != 1" @click.prevent="$emit('apri-azioni-voce', { azione: 'elimina', voce, attivita }); closeDropdown()">
												<i class="far fa-trash-alt fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_ELIMINA'"></Translate>
											</a>
											<a href="#" class="dropdown-item text-danger" v-if="$root.isGod && voce.FLG_ELIMINATO == 1" @click.prevent="$emit('apri-azioni-voce', { azione: 'elimina-definitivamente', voce, attivita }); closeDropdown()">
												<i class="far fa-trash fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_ELIMINA_DEF'"></Translate>
											</a>
											<a href="#" class="dropdown-item text-success" v-if="$root.isGod && voce.FLG_ELIMINATO == 1" @click.prevent="$emit('apri-azioni-voce', { azione: 'ripristina', voce, attivita }); closeDropdown()">
												<i class="far fa-redo fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_RIPRISTINA'"></Translate>
											</a>
										</div>
									</Teleport>
								</div>
							</div>
						</div>
						<div v-else class="d-flex align-items-center flex-shrink-0 ms-2">
							<span class="badge bg-primary bg-opacity-20 text-primary me-1" style="font-size:0.7rem;">&euro; {{ voce.TOTAL_PRICE }}</span>
							<span class="badge bg-danger bg-opacity-20 text-danger" style="font-size:0.7rem;">&euro; {{ voce.TOTAL_COST_ESPOSTO }}</span>
							<i v-if="dragEnabled" class="ph-dots-six-vertical drag-handle-voce cursor-move ms-2" :title="$root.translate('dizionario.attivita.TRASCINA_SPOSTA_VOCE')" @click.stop></i>
							<div v-if="!readOnly && !dragEnabled" class="dropdown ms-2" ref="dropdownEl" @click.stop>
								<a
									href="#"
									class="text-body p-0"
									@click.prevent="toggleDropdown"
									:aria-expanded="dropdownOpen"
									:title="$root.translate('dizionario.base.AZIONI')"
									ref="dropdownToggle"
								>
									<i class="ph-list"></i>
								</a>

								<Teleport to="body">
									<div
										v-if="dropdownOpen"
										class="dropdown-menu dropdown-menu-end show"
										:style="dropdownStyle"
										@click="handleMenuClick"
									>
										<a href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni-voce', { azione: 'modifica', voce, attivita }); closeDropdown()">
											<i class="far fa-edit fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_MODIFICA'"></Translate>
										</a>
										<a href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni-voce', { azione: 'aggiungi-preferito', voce, attivita }); closeDropdown()">
											<i class="far fa-star fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.attivita.AGGIUNGI_PREFERITI'"></Translate>
										</a>
										<a href="#" class="dropdown-item" v-if="$root.isGod" @click.prevent="toggleFlgAttivoVoce(voce.FLG_ATTIVO_VOCE == 1 ? 0 : 1); closeDropdown()">
											<i :class="voce.FLG_ATTIVO_VOCE == 1 ? 'far fa-times-circle' : 'far fa-check-circle'" class="fa-fw me-2"></i><span class="text-muted me-1">|</span>{{ $root.translate(voce.FLG_ATTIVO_VOCE == 1 ? 'dizionario.base.BTN_DISATTIVA' : 'dizionario.base.BTN_ATTIVA') }}
										</a>
										<div class="dropdown-divider" v-if="$root.isGod"></div>
										<a href="#" class="dropdown-item text-danger" v-if="voce.FLG_ELIMINATO != 1" @click.prevent="$emit('apri-azioni-voce', { azione: 'elimina', voce, attivita }); closeDropdown()">
											<i class="far fa-trash-alt fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_ELIMINA'"></Translate>
										</a>
										<a href="#" class="dropdown-item text-danger" v-if="$root.isGod && voce.FLG_ELIMINATO == 1" @click.prevent="$emit('apri-azioni-voce', { azione: 'elimina-definitivamente', voce, attivita }); closeDropdown()">
											<i class="far fa-trash fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_ELIMINA_DEF'"></Translate>
										</a>
										<a href="#" class="dropdown-item text-success" v-if="$root.isGod && voce.FLG_ELIMINATO == 1" @click.prevent="$emit('apri-azioni-voce', { azione: 'ripristina', voce, attivita }); closeDropdown()">
											<i class="far fa-redo fa-fw me-2"></i><span class="text-muted me-1">|</span><Translate :path="'dizionario.base.BTN_RIPRISTINA'"></Translate>
										</a>
									</div>
								</Teleport>
							</div>
						</div>
					</div>

					<div v-if="mobileDetailExpanded" class="voce-mobile-details p-2 pt-0" @click.stop>
						<div class="row g-2">
							<div class="col-6">
								<small class="text-muted d-block"><Translate :path="'dizionario.attivita.QUANTITA'"></Translate></small>
								{{ parseFloat(voce.QUANTITY_PRICE) }}
							</div>
							<div class="col-6">
								<small class="text-muted d-block"><Translate :path="'dizionario.attivita.GIORNI'"></Translate></small>
								{{ parseFloat(voce.DAYS_PRICE) }}
							</div>
							<div class="col-6">
								<small class="text-muted d-block"><Translate :path="'dizionario.attivita.PREZZO_UNIT'"></Translate></small>
								<span v-if="voce.FLG_OMAGGIO_UNIT_PRICE == 1" class="badge bg-primary bg-opacity-20 text-primary" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
								<span v-else>&euro; {{ voce.UNIT_PRICE }}</span>
							</div>
							<div class="col-6">
								<small class="text-muted d-block"><Translate :path="'dizionario.attivita.TOTALE'"></Translate></small>
								<span v-if="voce.FLG_OMAGGIO_TOTAL_PRICE == 1" class="badge bg-primary bg-opacity-20 text-primary" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
								<template v-else>
									<span class="text-primary fw-semibold">&euro; {{ voce.TOTAL_PRICE }}</span>
									<span v-if="ivaCode" class="badge bg-secondary ms-1" style="font-size:0.65rem;" :title="ivaCode.DESCRIZIONE">{{ ivaCode.CUSTOM_1 }}</span>
									<span v-if="voce.FEE > 0" class="badge bg-info bg-opacity-20 text-info ms-1" style="font-size:0.65rem;" :title="'Fee: ' + voce.FEE + '%'">fee {{ voce.FEE }}%</span>
								</template>
							</div>
							<div class="col-6">
								<small class="text-muted d-block"><Translate :path="'dizionario.attivita.COSTO_UNIT'"></Translate></small>
								<span v-if="voce.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1" class="badge bg-danger bg-opacity-20 text-danger" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
								<span v-else>&euro; {{ voce.UNIT_COST_ESPOSTO }}</span>
							</div>
							<div class="col-6">
								<small class="text-muted d-block"><Translate :path="'dizionario.attivita.COSTI'"></Translate></small>
								<span v-if="voce.FLG_OMAGGIO_UNIT_COST_ESPOSTO == 1" class="badge bg-danger bg-opacity-20 text-danger" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
								<template v-else>
									<span class="text-danger fw-semibold">&euro; {{ voce.TOTAL_COST_ESPOSTO }}</span>
									<span v-if="ivaCodiceAcquisto" class="badge bg-secondary ms-1" style="font-size:0.65rem;" :title="ivaCodiceAcquisto.DESCRIZIONE">{{ ivaCodiceAcquisto.CUSTOM_1 }}</span>
								</template>
							</div>
							<div class="col-6">
								<small class="text-muted d-block"><Translate :path="'dizionario.attivita.COMMISSIONI'"></Translate></small>
								<span v-if="voce.FLG_OMAGGIO_TOTAL_COST_PRIVATO == 1" class="badge bg-warning bg-opacity-20 text-warning" style="font-size:0.65rem;"><Translate :path="'dizionario.attivita.OMAGGIO'"></Translate></span>
								<template v-else>
									<span class="text-warning fw-semibold">&euro; {{ voce.TOTAL_COST_PRIVATO }}</span>
									<span v-if="ivaCodiceCommissioni" class="badge bg-secondary ms-1" style="font-size:0.65rem;" :title="ivaCodiceCommissioni.DESCRIZIONE">{{ ivaCodiceCommissioni.CUSTOM_1 }}</span>
								</template>
							</div>
							<div class="col-6">
								<small class="text-muted d-block"><Translate :path="'dizionario.base.FORNITORE'"></Translate></small>
								<span v-if="voce.FORNITORE">{{ filters.accorciaTesto(voce.FORNITORE, 50) }}</span>
								<span v-else class="text-muted fst-italic">-</span>
							</div>
						</div>
					</div>
				</div>
			</td>
		</template>
	</tr>
</template>

<script>
import { useDropdownManager } from '@/composables/useDropdownManager.js'
import Translate from '@/components/utils/Translate.vue'
import { ref } from 'vue'

export default {
	name: 'VoceNode',

	components: {
		/* ISwitch, */
		Translate,
	},

	props: {
		voce: {
			type: Object,
			required: true,
		},
		depth: {
			type: Number,
			default: 0,
		},
		attivita: {
			type: Object,
			required: true,
		},
		readOnly: {
			type: Boolean,
			default: false,
		},
		dragEnabled: {
			type: Boolean,
			default: true,
		},
	},

	emits: ['refresh', 'apri-azioni-voce'],

	setup() {
		const dropdownManager = useDropdownManager();
		const dropdownId = ref(null);
		const dropdownOpen = ref(false);
		const dropdownStyle = ref({});
		const dropdownToggle = ref(null);

		return {
			dropdownManager,
			dropdownId,
			dropdownOpen,
			dropdownStyle,
			dropdownToggle,
		};
	},

	data() {
		return {
			filters: global.filters,
			titleExpanded: false,
			mobileDetailExpanded: false,
		}
	},

	computed: {
		isTitleTruncated() {
			return this.voce.TITOLO_VOCE &&
				this.voce.TITOLO_VOCE.toString().length > 100;
		},

		ivaCode() {
			if (!this.voce.FK_ID_IVA_PREZZO) return null;
			return (this.$root.arrayCodiciIva || []).find(
				c => c.ID_OPZIONE_TIPOLOGICA == this.voce.FK_ID_IVA_PREZZO
			) || null;
		},

		ivaCodiceAcquisto() {
			if (!this.voce.FK_ID_IVA_COSTO) return null;
			return (this.$root.arrayCodiciIva || []).find(
				c => c.ID_OPZIONE_TIPOLOGICA == this.voce.FK_ID_IVA_COSTO
			) || null;
		},

		ivaCodiceCommissioni() {
			if (!this.voce.FK_ID_IVA_COMMISSIONI) return null;
			return (this.$root.arrayCodiciIva || []).find(
				c => c.ID_OPZIONE_TIPOLOGICA == this.voce.FK_ID_IVA_COMMISSIONI
			) || null;
		},
	},

	mounted() {
		// Registra questo dropdown nel sistema centralizzato
		this.dropdownId = this.dropdownManager.registerDropdown(() => {
			this.closeDropdown();
		});

		// Gestisci click fuori dal dropdown per chiuderlo
		document.addEventListener('click', this.handleOutsideClick);
	},

	beforeUnmount() {
		// Pulisci il dropdown dal registro
		if (this.dropdownId) {
			this.dropdownManager.unregisterDropdown(this.dropdownId);
		}
		document.removeEventListener('click', this.handleOutsideClick);
	},

	methods: {
		toggleDropdown() {
			if (this.dropdownOpen) {
				this.closeDropdown();
			} else {
				this.openDropdown();
			}
		},

		openDropdown() {
			// Notifica il manager per chiudere altri dropdown
			this.dropdownManager.openDropdown(this.dropdownId);
			this.dropdownOpen = true;

			// Calcola la posizione del dropdown
			this.$nextTick(() => {
				this.updateDropdownPosition();
			});
		},

		closeDropdown() {
			this.dropdownOpen = false;
			this.dropdownManager.closeDropdown(this.dropdownId);
		},

		updateDropdownPosition() {
			if (!this.$refs.dropdownToggle) return;

			const toggle = this.$refs.dropdownToggle;
			const rect = toggle.getBoundingClientRect();
			const dropdownWidth = 200; // Larghezza approssimativa del dropdown
			const padding = 10; // Padding dal bordo della viewport

			// Calcola la posizione a destra (align-end)
			let leftPos = rect.left - dropdownWidth + toggle.offsetWidth;

			// Verifica se il dropdown esce dal viewport a destra
			if (leftPos + dropdownWidth + padding > window.innerWidth) {
				// Se esce, posiziona dalla parte opposta
				leftPos = rect.left - (dropdownWidth - toggle.offsetWidth) - padding;
				// Se comunque non entra, usa il minimo necessario
				if (leftPos < padding) {
					leftPos = padding;
				}
			}

			// Assicura che non esce dal lato sinistro
			if (leftPos < padding) {
				leftPos = padding;
			}

			this.dropdownStyle = {
				position: 'fixed',
				top: `${rect.bottom + 2}px`,
				left: `${leftPos}px`,
				zIndex: '99999',
				maxWidth: 'calc(100vw - 20px)', // Evita che il dropdown sia più largo della viewport
			};
		},

		handleOutsideClick(event) {
			if (!this.dropdownOpen) return;

			const dropdownEl = this.$refs.dropdownEl;
			const toggle = this.$refs.dropdownToggle;

			if (dropdownEl && !dropdownEl.contains(event.target) &&
			    toggle && !toggle.contains(event.target)) {
				this.closeDropdown();
			}
		},

		handleMenuClick(event) {
			// Previeni la propagazione del click per evitare che chiuda il dropdown prematuramente
			event.stopPropagation();
		},

		updateFlgDaCalcolareVoce(newFlagValue) {
			utils.ajax('theb/voce/update', {
				ID_VOCE: this.voce.ID_VOCE,
				TITOLO: this.voce.TITOLO_VOCE,
				FLG_DA_CALCOLARE: newFlagValue,
			}, (response) => {
				if (response.esito == 0) {
					this.$emit('refresh');
				}
			});
		},

		toggleFlgAttivoVoce(newFlagValue) {
			utils.ajax('theb/voce/update', {
				ID_VOCE: this.voce.ID_VOCE,
				TITOLO: this.voce.TITOLO_VOCE,
				FLG_ATTIVO: newFlagValue,
			}, (response) => {
				if (response.esito == 0) {
					this.$emit('refresh');
				}
			});
		},
	},
}
</script>

<style scoped>
/* Drag Handle */
.drag-handle-voce {
	opacity: 0.4;
	transition: opacity 0.2s;
}

.drag-handle-voce:hover {
	opacity: 1;
}

/* Voce Row */
tr {
	transition: background-color 0.2s ease;
	position: relative;
}

tr:hover {
	background-color: rgba(0, 0, 0, 0.02) !important;
}

/* Fix dropdown in table */
.actions-cell {
	position: static;
}

.dropdown {
	position: relative;
}

/* Colori bordi laterali per le celle della voce */
.voce-cell {
	text-align: right;
}

.voce-cell-index {
	text-align: center;
}

.voce-cell-vendita {
	text-align: left;
}

.voce-cell-vendita:not(:first-of-type) {
	text-align: right;
}

.voce-cell-acquisto {
	text-align: right;
}

.voce-cell-fornitore {
	text-align: right;
}

.voce-cell-actions {
	text-align: center;
}

/* Mobile card */
.voce-mobile-cell {
	text-align: left;
}

.voce-mobile-row {
	cursor: pointer;
}

.voce-mobile-details {
	background-color: rgba(0, 0, 0, 0.02);
	border-top: 1px solid #e8e8e8;
	font-size: 0.8rem;
}

.min-w-0 {
	min-width: 0;
}

</style>
